
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 51 51","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"25.5","cy":"25.5","r":"25.5","fill":"#FFC654"}}),_c('path',{attrs:{"d":"M25.5 35.667c.576 0 1.06-.195 1.45-.585.389-.39.583-.872.583-1.448s-.194-1.06-.583-1.45c-.39-.39-.874-.584-1.45-.584s-1.059.195-1.448.584c-.39.39-.585.874-.585 1.45s.195 1.058.585 1.448c.39.39.872.585 1.448.585zm-2.033-8.134h4.066v-12.2h-4.066zM25.5 45.834c-2.813 0-5.456-.534-7.93-1.602-2.474-1.067-4.626-2.515-6.457-4.345-1.83-1.83-3.278-3.983-4.345-6.457-1.068-2.474-1.602-5.117-1.602-7.93 0-2.813.534-5.456 1.602-7.93 1.067-2.474 2.515-4.627 4.345-6.457 1.83-1.83 3.983-3.279 6.457-4.347 2.474-1.067 5.117-1.6 7.93-1.6 2.813 0 5.456.533 7.93 1.6 2.474 1.068 4.626 2.517 6.457 4.347 1.83 1.83 3.278 3.983 4.345 6.457 1.068 2.474 1.602 5.117 1.602 7.93 0 2.813-.534 5.456-1.602 7.93-1.067 2.474-2.515 4.626-4.345 6.457-1.83 1.83-3.983 3.278-6.457 4.345-2.474 1.068-5.117 1.602-7.93 1.602zm0-4.067c4.541 0 8.388-1.575 11.54-4.727 3.152-3.152 4.727-6.999 4.727-11.54 0-4.541-1.575-8.388-4.727-11.54-3.152-3.152-6.999-4.728-11.54-4.728-4.541 0-8.388 1.576-11.54 4.728-3.152 3.152-4.728 6.999-4.728 11.54 0 4.541 1.576 8.388 4.728 11.54 3.152 3.152 6.999 4.727 11.54 4.727z","fill":"#fff"}})])
          )
        }
      }
    